import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('Trading Ideas')

/** 👇 View stock pick */
const ViewCaseStudy = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - view stock pick',
  name: 'view_cs',
});

/** 👇 users click latest */
const ClickLatest = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click latest',
  name: 'click_latest',
});

/** 👇 users click watchlist */
const ClickWatchlist = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click watchlist',
  name: 'click_watchlist',
});

/** 👇 users click beli */
const ClickBeli = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click beli',
  name: 'click_beli',
});

/** 👇 users click hold */
const ClickHold = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click hold',
  name: 'click_hold',
});

/** 👇 users click jual */
const ClickJual = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click jual',
  name: 'click_jual',
});

/** 👇 users click note */
const ClickNote = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click note',
  name: 'click_note',
});

/** 👇 users click information */
const ClickInformation = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click information',
  name: 'click_information',
});

/** 👇 users click search */
const ClickSearch = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click search',
  name: 'click_search',
});

/** 👇 users click strategy,
 * strategy = 'scalping,jangka pendek,jangka menengah, jangka panjang',
 */
const ClickStrategy = ({ strategy = '', action = '' }) => analytics({
  label: GenerateLabel({ action, strategy, removeUser: true }),
  action: 'stock pick - click strategy',
  name: 'click_strategy',
});

/** 👇 users click filter */
const ClickFilterCaseStudy = () => analytics({
  label: GenerateLabel({}),
  action: 'stock pick - click filter',
  name: 'click_filter_cs',
});

/** 👇 users filter stock pick (click ok),
 * duration = 'today/yesterday/last 7 days/last 14 days/last 30 days'
 */
const FilterCaseStudy = ({ duration = '' }) => analytics({
  label: GenerateLabel({ duration, removeUser: true }),
  action: 'stock pick - filter stock pick',
  name: 'filter_cs',
});

/** 👇 users click stock pick detail,
 * signal = 'buy/sell'
 * strategy = 'scalping/jangka pendek/jangka menengah/jangka panjang'
 */
const ClickCaseStudyDetail = ({
  emiten = '',
  signal = '',
  strategy = '',
}) => analytics({
  label: GenerateLabel({ emiten, signal, strategy, removeUser: true }),
  action: 'stock pick - click stock pick detail',
  name: 'click_cs_detail',
});

/** 👇 user click analysis button on stock pick detail,
 * tab = 'latest/beli/hold'
 */
const ClickCaseStudyDetailAnalysis = ({
  tab = '',
  emiten = '',
}) => analytics({
  label: GenerateLabel({ tab, emiten, removeUser: true }),
  action: 'stock pick - view analysis',
  name: 'click_cs_detail',
});

const CaseStudy = {
  ViewCaseStudy,
  ClickLatest,
  ClickWatchlist,
  ClickBeli,
  ClickHold,
  ClickJual,
  ClickNote,
  ClickInformation,
  ClickSearch,
  ClickStrategy,
  ClickFilterCaseStudy,
  FilterCaseStudy,
  ClickCaseStudyDetail,
  ClickCaseStudyDetailAnalysis,
};

export default CaseStudy;
